import { Controller } from "@hotwired/stimulus"
import Tags from "bootstrap5-tags";

const parseBool = (value) => {
  if (value === undefined) return undefined;
  return ["true", "1", "yes", "on"].includes(value.toString().toLowerCase());
};

const parseArray = (value) => {
  if (!value) return [];

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [parsed].filter(Boolean);
  } catch (error) {
    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }
};

// Connects to data-controller="task-tag"
export default class extends Controller {
  static targets = ["element"]

  connect() {
    const element = this.elementTarget;
    const { dataset } = element;

    const options = {
      allowClear: true,
      allowNew: parseBool(dataset.allowNew) ?? false,
      server: dataset.server || undefined,
      liveServer: parseBool(dataset.liveServer) ?? false,
      labelField: dataset.labelfield || "label",
      valueField: dataset.valuefield || "value",
      searchFields: dataset.searchfields
        ? dataset.searchfields.split(",").map((field) => field.trim()).filter(Boolean)
        : [dataset.labelfield || "label"],
      placeholder: dataset.placeholder || undefined,
      selected: parseArray(dataset.selected),
      fixed: true,
    };

    Tags.init(`#${element.id}`, options);
  }
}
